<template>
  <div class="honor-container">
    <div class="block-title">荣誉资质</div>

    <div class="img-block">
      <img src="~@/assets/zz_als.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/zz_la.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/zz_hf.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss">
.honor-container {
  .img-block {
    margin-bottom: 20px;
  }
}
</style>
